import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { FilterService } from '../../../core/+state/filter.service';

@Component({
  selector: 'locumsnest-common',
  template: '',
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommonComponent implements OnInit {
  private filterService = inject(FilterService);

  ngOnInit() {
    this.filterService.initializeFilters();
  }
}
